<style>
@import '../../../custom/css/lista-dicas.css';

/* #representantes .limit-table::-webkit-scrollbar:vertical {
  display: none;
} */
</style>

<template>
  <div id="representantes">
    <h1 class="title text-uppercase font-weight-bold">Boletos Pendentes</h1>
    <hr class="linha-amarela" />
    <table class="table" v-if="getPendingBillets.length > 0">
      <thead class="letter-orange">
        <tr>
          <th></th>
          <th>Nome Afiliado</th>
          <th>Nome da Loja</th>
          <th>Vencimento</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(pendinBillet, index) in getPendingBillets" :key="index">
          <td class="font-weight-bold fs-20">
            {{ index + 1 }}
          </td>
          <td>
            {{ pendinBillet.nome_afiliado }}
          </td>
          <td>
            {{ pendinBillet.nome_lojista }}
          </td>
          <td>
            {{ pendinBillet.data_vencimento }}
          </td>
          <td>
            <b-btn
              class="btn-warning mr-1"
              @click="
                see(
                  pendinBillet.id,
                  pendinBillet.afiliado_id,
                  pendinBillet.lojista_id
                )
              "
              title="Ver"
            >
              <i class="fas fa-eye"></i>
            </b-btn>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-else>
      <p>Sem boletos pendentes</p>
    </div>
    <b-modal
      size="lg"
      title="Boleto Pendente"
      id="seePendingBilletInformation"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
      no-close-on-backdrop
      @close="Fields.paymentStatus = null"
      @hide="Fields.paymentStatus = null"
    >
      <div class="row">
        <section
          class="col-8"
          v-if="getPendingBilletInformation.shopkeeper !== undefined"
        >
          <div
            class="text-center my-4 text-uppercase c-orange font-weight-bold"
          >
            <p>Informações do Lojista:</p>
          </div>
          <div class="row mb-4">
            <div class="col-4">
              <span class="font-weight-bold">Nome Fantasia</span>
              <p>{{ getPendingBilletInformation.shopkeeper.nome_fantasia }}</p>
            </div>
            <div class="col-4">
              <span class="font-weight-bold">CNPJ</span>
              <p>{{ getPendingBilletInformation.shopkeeper.cnpj }}</p>
            </div>
            <div class="col-4">
              <span class="font-weight-bold">Celular</span>
              <p>{{ getPendingBilletInformation.shopkeeper.celular }}</p>
            </div>
          </div>
          <div class="row mb-4">
            <div class="col-4">
              <span class="font-weight-bold">Endereço</span>
              <p>{{ getPendingBilletInformation.shopkeeper.endereco }}</p>
            </div>
            <div class="col-4">
              <span class="font-weight-bold">Número</span>
              <p>
                {{
                  getPendingBilletInformation.shopkeeper.numero || 'Sem número'
                }}
              </p>
            </div>
            <div class="col-4">
              <span class="font-weight-bold">Complemento</span>
              <p>
                {{
                  getPendingBilletInformation.shopkeeper.complemento ||
                  'Sem complemento'
                }}
              </p>
            </div>
          </div>
          <div class="row mb-4">
            <div class="col-4">
              <span class="font-weight-bold">CEP</span>
              <p>{{ getPendingBilletInformation.shopkeeper.cep }}</p>
            </div>
            <div class="col-4">
              <span class="font-weight-bold">Bairro</span>
              <p>{{ getPendingBilletInformation.shopkeeper.bairro }}</p>
            </div>
            <div class="col-4">
              <span class="font-weight-bold">Cidade</span>
              <p>{{ getPendingBilletInformation.shopkeeper.cidade }}</p>
            </div>
          </div>
        </section>
        <section
          class="col-4"
          v-if="getPendingBilletInformation.affiliate !== undefined"
        >
          <div
            class="text-center my-4 text-uppercase c-orange font-weight-bold"
          >
            <p>Informações do Afiliado:</p>
          </div>
          <div class="row mb-4">
            <div class="col-6">
              <span class="font-weight-bold">Nome</span>
              <p>{{ getPendingBilletInformation.affiliate.nome }}</p>
            </div>
            <div class="col-6">
              <span class="font-weight-bold">Cidade</span>
              <p>{{ getPendingBilletInformation.affiliate.cidade }}</p>
            </div>
          </div>
          <div class="row mb-4">
            <div class="col-6">
              <span class="font-weight-bold">Telefone</span>
              <p>{{ getPendingBilletInformation.affiliate.telefone }}</p>
            </div>
            <div class="col-6">
              <span class="font-weight-bold">Telefone 2</span>
              <p>
                {{
                  getPendingBilletInformation.affiliate.telefone2 ||
                  'Sem telefone 2'
                }}
              </p>
            </div>
          </div>
          <div class="row mb-4">
            <div class="col-6">
              <span class="font-weight-bold">Celular</span>
              <p>{{ getPendingBilletInformation.affiliate.celular }}</p>
            </div>
          </div>
          <div v-if="hasWritePermission()" class="col-12 w-100 px-0">
            <v-select
              class="mt-4 w-100"
              label="name"
              placeholder="Status do pagamento"
              v-model="Fields.paymentStatus"
              :options="paymentStatus"
              :reduce="(status) => status.value"
            >
            </v-select>
          </div>
          <div v-if="hasWritePermission()" class="col-12">
            <b-button
              variant="success"
              type="button"
              class="mt-4 w-75"
              @click="change()"
            >
              Atualizar Status
            </b-button>
          </div>
        </section>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import makeToast from '../../../mixins/makeToast';

export default {
  name: 'PendingBillets',
  mixins: [makeToast],
  data() {
    return {
      currentPendingBillet: 0,
      Fields: {
        paymentStatus: null,
      },
      paymentStatus: [
        { name: 'Pagamento aprovado', value: 'aprovado' },
        { name: 'Pagamento rejeitado', value: 'rejeitado' },
      ],
    };
  },
  computed: {
    ...mapGetters('admin', [
      'getPendingBillets',
      'getPendingBilletInformation',
    ]),
    ...mapState(['token', 'dadosUsuario']),
  },
  created() {
    this.$store.dispatch('startLoader');
    this.getAffiliatePendingBillets().finally(() =>
      this.$store.dispatch('endLoader')
    );
  },
  methods: {
    ...mapActions('admin', [
      'getAffiliatePendingBillets',
      'getAffiliatePendingBilletInformation',
      'changeBilletStatus',
    ]),
    see(pendingBilletId, affiliateId, shopkeeperId) {
      const ids = {
        pendingBilletId,
        affiliateId,
        shopkeeperId,
      };

      this.$store.dispatch('startLoader');
      this.getAffiliatePendingBilletInformation(ids)
        .then(() => {
          this.currentPendingBillet = pendingBilletId;
          this.Fields.paymentStatus =
            this.getPendingBilletInformation.billet.status;
          this.$bvModal.show('seePendingBilletInformation');
        })
        .catch(() => {
          this.makeToast(
            'Oopss',
            'Houve algum problema ao visualizar esse boleto pendente usuário',
            'danger'
          );
        })
        .finally(() => this.$store.dispatch('endLoader'));
    },
    change() {
      const data = {
        pendingBilletId: this.currentPendingBillet,
        newStatus: this.Fields.paymentStatus,
      };

      this.$store.dispatch('startLoader');
      this.changeBilletStatus(data)
        .then((response) => {
          this.makeToast('Sucesso!', response.data.message);

          this.$bvModal.hide('seePendingBilletInformation');

          this.$store.dispatch('startLoader');
          this.getAffiliatePendingBillets().finally(() =>
            this.$store.dispatch('endLoader')
          );
        })
        .catch((error) => {
          this.makeToast('Oopss!', error.response.data.message, 'danger');
        })
        .finally(() => this.$store.dispatch('endLoader'));
    },
    hasWritePermission() {
      return this.dadosUsuario.permitido_escrita == 1;
    },
  },
};
</script>
